<template>
<!-- 企业信息  -->
    <div>
        <div><el-button type="primary" size="small" @click="addCompanyInfo">添加</el-button></div> 
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="province" label="省份" width="70"></el-table-column>
            <el-table-column prop="city" label="城市" width="80"></el-table-column>
            <el-table-column prop="district" label="县区" width="80"></el-table-column>
            <el-table-column prop="townOrStreet" label="镇/街道" width="100"></el-table-column>
            <el-table-column prop="address" label="地址" width="200"></el-table-column>
            <el-table-column prop="name" label="公司名称" width="150"></el-table-column>
            <el-table-column prop="telPhone" label="联系电话" width="140"></el-table-column>
            <el-table-column prop="typeDescr" label="公司类型" width="80"></el-table-column>
            <el-table-column prop="latitude" label="纬度" width="100"></el-table-column>
            <el-table-column prop="longitude" label="精度" width="100"></el-table-column>
            <el-table-column prop="countryCode" label="国家二字码" width="100"></el-table-column>
            <el-table-column prop="copyright" label="版权" width="150"></el-table-column>
            <el-table-column prop="email" label="电子邮箱" width="150"></el-table-column>
            <el-table-column prop="establishmentDate" label="成立日期" width="120"></el-table-column>
            <el-table-column prop="postalCode" label="邮编" width="70"></el-table-column>
            <el-table-column prop="recordNumber" label="备案号" width="150"></el-table-column>
            <el-table-column prop="content" label="描述信息" width="150"></el-table-column>
            <el-table-column label="操作" width="230" fixed="right">
                <template slot-scope="scope" >
                    <el-button size="mini" @click="updataCompanyInfo(scope.row)">编辑</el-button>&ensp;
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deleteCompanyInfo(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                    <el-button type="text" style="padding:0;margin-left:10px;" :disabled="scope.$index == 0" @click="moveUpward(scope.row.id, scope.$index)">上移</el-button>
                    <el-button type="text" style="padding:0" :disabled="(scope.$index + 1) == tableData.length" @click="moveDown(scope.row.id, scope.$index)">下移</el-button>
                </template>
            </el-table-column>
        </el-table>
        
        <el-dialog :title="title+'企业信息'" :visible.sync="dialogFormVisible" class="personalInfo">
            <el-form :model="operObj" ref="downloadObj">
                <el-form-item label="省份" class="labelWidth">
                    <el-input v-model="operObj.province" ></el-input>
                </el-form-item>
                <el-form-item label="城市" class="labelWidth" prop="name">
                    <el-input v-model="operObj.city" ></el-input>
                </el-form-item>
                <el-form-item label="县区" class="labelWidth">
                    <el-input v-model="operObj.district"></el-input>
                </el-form-item>
                <el-form-item label="镇/街道" class="labelWidth">
                    <el-input v-model="operObj.townOrStreet"></el-input>
                </el-form-item>
                <el-form-item label="地址" class="labelWidth">
                    <el-input v-model="operObj.address"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" class="labelWidth">
                    <el-input v-model="operObj.name"></el-input>
                </el-form-item>
                <el-form-item label="精度" class="labelWidth">
                    <el-input v-model="operObj.longitude"></el-input>
                </el-form-item>
                <el-form-item label="纬度" class="labelWidth">
                    <el-input v-model="operObj.latitude"></el-input>
                </el-form-item>
                <el-form-item label="公司类型" class="labelWidth">
                    <el-select v-model="operObj.typeDescr" placeholder="请选择">
                        <el-option label="总部" value="总部"></el-option>
                        <el-option label="分部" value="分部"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="国家二字码" class="labelWidth">
                    <el-input v-model="operObj.countryCode"></el-input>
                </el-form-item>
                <el-form-item label="版权" class="labelWidth">
                    <el-input v-model="operObj.copyright"></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱" class="labelWidth">
                    <el-input v-model="operObj.email"></el-input>
                </el-form-item>
                <el-form-item label="成立日期" class="labelWidth">
                    <el-date-picker
                        v-model="operObj.establishmentDate"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="邮编" class="labelWidth">
                    <el-input v-model="operObj.postalCode"></el-input>
                </el-form-item>
                <el-form-item label="备案号" class="labelWidth">
                    <el-input v-model="operObj.recordNumber"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" class="labelWidth">
                    <el-input v-model="operObj.telPhone"></el-input>
                </el-form-item>
                <el-form-item label="描述信息" class="labelWidth">
                    <el-input v-model="operObj.content"></el-input>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpdate">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// getCompanyInfo       查询公司中心信息
// deleteCompanyInfo    删除公司中心信息
// saveCompanyInfo      保存公司中心信息
// updateCompanyInfo    修改公司中心信息
// changeSort           调整企业信息排序
import { 
getCompanyInfo,
deleteCompanyInfo,
saveCompanyInfo,
updateCompanyInfo,
changeSort} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteCompanyInfo',

    data() {
        return {
            // 企业信息
            tableData: [],
            // 标题
            title:'',
            dialogFormVisible:false,
            // 要修改或者要增加
            operObj:{
                city:'',
                province:'',
                district:'',
                townOrStreet:'',
                address:'',
                name:'',
                typeDescr:'',
                latitude:'',
                longitude:'',
                countryCode:'',
                copyright:'',
                email:'',
                establishmentDate:'',
                postalCode:'',
                recordNumber:'',
                telPhone:'',
                content:'',
                id:'',
            },
        };
    },

    mounted() {
        
    },

    methods: {
        // 上移
        async moveUpward(id, index) {
            if (index > 0) {
                let upData = this.tableData[index - 1];
                this.tableData.splice(index - 1, 1);
                this.tableData.splice(index, 0, upData);
                let res = await changeSort({id,isUp:true});
                if(res.code == 200){
                    this.$message({
                        message: '调整成功！',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: '调整失败！',
                        type: 'error'
                    });
                }
            } else {
                this.$message({
                    message: '已经是第一条，上移失败',
                    type: 'warning'
                });
            }
        },
        // 下移
        async moveDown(id, index) {
            if ((index + 1) == this.tableData.length) {
                this.$message({
                    message: '已经是最后一条，下移失败',
                    type: 'warning'
                });
            } else {
                let downData = this.tableData[index + 1];
                this.tableData.splice(index + 1, 1);
                this.tableData.splice(index, 0, downData);
                let res = await changeSort({id,isUp:false});
                if(res.code == 200){
                    this.$message({
                        message: '调整成功！',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: '调整失败！',
                        type: 'error'
                    });
                }

            }
        },
        // 查询下载列表
        async selectCompanyInfo(){
            let res = await getCompanyInfo();
            this.tableData = res.data
        },
        // 删除
        async deleteCompanyInfo(id){
            let res = await deleteCompanyInfo(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectCompanyInfo()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
        // 修改企业信息
        async updataCompanyInfo(obj){
            this.dialogFormVisible = true
            Object.keys(obj).forEach(key1 => {
                Object.keys(this.operObj).forEach(key2 => {
                    if(key1 == key2){
                        this.operObj[key2] = obj[key1] 
                    }
                })
            })
            this.title = '修改'
        },
        // 新增
        addCompanyInfo(){
            Object.keys(this.operObj).forEach(key => {
                this.operObj[key] = ''
            })
            this.title = '新增'
            this.dialogFormVisible = true

        },
        // 提交修改
        async submitUpdate(){
            let res;
            if(this.title == '修改'){
                res = await updateCompanyInfo(this.operObj);
                
            }else{  //新增
                res = await saveCompanyInfo(this.operObj);
            }
            if(res.code == 200){
                this.$message({ message: this.title+'成功！', type: 'success' });
                this.selectCompanyInfo()
                this.dialogFormVisible = false
            }else{
                this.$message({message: this.title+''+res.msg+'！',type: 'error'});
            }


        }
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectCompanyInfo()
    }
};
</script>

<style lang="scss" scoped></style>